import { useQuery } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';
import type { MissionControlVersion } from '@v2/types';

interface UseMissionControlVersionsResult {
  versions: MissionControlVersion[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useMissionControlVersions(enabled = true): UseMissionControlVersionsResult {
  const query = useQuery({
    queryKey: queryKeys.missionControl.versions.lists(),
    queryFn: missionControlService.getAllVersions,
    enabled,
  });

  return {
    versions: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: async () => {
      await query.refetch();
    },
  };
}

export default useMissionControlVersions;
